import authReducer from 'store/auth/authSlice';
import deviceReducer from 'store/device/deviceSlice';
import appReducer from 'store/app/appSlice';
import rangeReducer from 'store/range/rangeSlice';
import profileReducer from 'store/profile/profileSlice';
import licenceReducer from 'store/licence/licenceSlice';
import reportReducer from 'store/report/reportSlice';
import searchbarReducer from 'store/searchbar/searchbarSlice';
import userReducer from 'store/settings/user/userSlice';
import staleQueriesReducer from 'store/cache/staleQueriesSlice';
import { authApi, dataApi } from 'services/data/DataService';
import { combineReducers } from '@reduxjs/toolkit';
import { restorePersistedState } from './persistence/restoreActions';
import persistenceConfig from './persistence/persistenceConfig';

const reducers = {
  auth: authReducer,
  device: deviceReducer,
  app: appReducer,
  searchbar: searchbarReducer,
  range: rangeReducer,
  profile: profileReducer,
  licence: licenceReducer,
  report: reportReducer,
  user: userReducer,
  staleQueries: staleQueriesReducer,
  [dataApi.reducerPath]: dataApi.reducer,
  [authApi.reducerPath]: authApi.reducer
};

const combinedReducer = combineReducers(reducers);

export const rootReducer = (state, action) => {
  if (restorePersistedState.match(action)) {
    const nextState = { ...state };

    for (const [sliceName, config] of Object.entries(persistenceConfig)) {     
      const currentSlice = state?.[sliceName];
      const persistedSlice = action.payload?.[sliceName];

      if (
        !state[sliceName] ||
        !persistedSlice ||
        typeof persistedSlice !== 'object' ||
        Array.isArray(persistedSlice)
      ) {
        continue;
      }

      nextState[sliceName] = {
        ...currentSlice,
        ...Object.fromEntries(
          config.fields
            .filter((field) => field in persistedSlice)
            .map((field) => [field, persistedSlice[field]])
        )
      };
    }

    return nextState;
  }

  return combinedReducer(state, action);
};